<template>
    <div class="m-question m-question-type-2 relative" :class="'active-'+selected">
        <div class="m-question--stone_l relative mx-auto">
            <div class="drop">
              <div id="dropzone">
              <div class="dropzone--layout">
                <div class="dropzone--dropzone">
                  <div class="m-question--pine dropzone--draggable"></div>
                </div>
              </div>
              <ul class="m-question--trunk flex jc-sa ai-c dropzone--layout">
                <li class="relative dropzone--dropzone" data-key="0"></li>
                <li class="relative dropzone--dropzone" data-key="1"></li>
                <li class="relative dropzone--dropzone" data-key="2"></li>
                <li class="relative dropzone--dropzone" data-key="3"></li>
              </ul>
            </div>
            </div>
            <div class="m-question--squirrel"></div>
            <div class="m-question--stone_s"></div>
        </div>
    </div>
</template>

<script>
import { Droppable } from '@shopify/draggable'
export default {
  name: 'QuestionType2',
  props: {
    keys: Number
  },
  watch: {
    selected: {
      handler: function (newValue) {
        const ele = this.$parent.$refs.answerBar[0]
        for (let i = 0; i < ele.children.length; i += 1) {
          ele.children[i].classList.remove('_active')
        }
        ele.children[newValue].classList.add('_active')
        if (newValue === '0') {
          this.$parent.selectAns(this.keys, 0)
        }
        if (newValue === '1') {
          this.$parent.selectAns(this.keys, 1)
        }
        if (newValue === '2') {
          this.$parent.selectAns(this.keys, 3)
        }
        if (newValue === '3') {
          this.$parent.selectAns(this.keys, 5)
        }
      }
    }
  },
  data () {
    return {
      selected: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      const containers = document.querySelectorAll('#dropzone')
      if (containers.length === 0) {
        return false
      }
      const dropper = new Droppable(containers, {
        draggable: '.dropzone--draggable',
        dropzone: '.dropzone--dropzone'
      })
      let droppableOrigin

      dropper.on('drag:start', (evt) => {
        droppableOrigin = evt.originalSource.parentNode.dataset.dropzone
      })
      dropper.on('drag:stop', () => {
        setTimeout(() => {
          this.selected = document.querySelector('.draggable-dropzone--occupied').attributes['data-key'].value
        }, 100)
      })
      dropper.on('droppable:dropped', (evt) => {
        if (droppableOrigin !== evt.dropzone.dataset.dropzone) {
          evt.cancel()
        }
      })
      return dropper
    })
  }
}
</script>

<style scoped lang="scss">
.m-question {
  display: none;
    @include respond-to('1200') {
      display: block;
      &-type-2{
        // position: absolute;
        bottom: 0;
        height: 625px;
        // left: 0;
        // right: 0;
        .drop{
            transition: .25s ease-in-out;
            transform-origin: center;
          }
          &.active-0{
            .drop{
              transform: rotate(-7.5deg)
            }
          }
          &.active-1{
            .drop{
              transform: rotate(-3.75deg);
            }
          }
          &.active-2{
            .drop{
              transform: rotate(3.75deg);
            }
          }
          &.active-3{
            .drop{
              transform: rotate(7.5deg);
            }
          }
      }
      &--trunk{
        position: absolute;
         background: url(~@/assets/ques_obj_trunk.png)center center/cover no-repeat;
        z-index: 2;
        top: -50px;
        left: calc(50% - 475px);
        width: 950px;
        height: 189px;
        padding: 0 15%;
        li{
          background: url(~@/assets/ques_obj_hole.png)center center/cover no-repeat;
          width: 75px;
          height: 75px;
          .m-question--pine{
            top: 0 !important;
          }
        }
      }
      &--squirrel{
        position: absolute;
        background: url(~@/assets/ques_obj_squirrel.png)center center/cover no-repeat;
        height: 111px;
        width: 115px;
        bottom: 98px;
        right: -50px;
      }
      &--stone_l{
        background: url(~@/assets/ques_obj_stone_l.png)center center/cover no-repeat;
        z-index: 1;
        height: 478px;
        width: 478px;
        bottom: -100px;
      }
      &--stone_s{
        position: absolute;
        background: url(~@/assets/ques_obj_stone_s.png)center center/cover no-repeat;
        height: 98px;
        width: 146px;
        bottom: 0;
        right: -95px;
      }
      &--pine{
        position: absolute;
        background: url(~@/assets/ques_obj_pine.png)center center/cover no-repeat;
        width: 75px;
        height: 75px;
        top: -75px;
        z-index: 5;
        left: calc(50% - 37.5px);
        cursor: grab;
        &.draggable-mirror{
          display: none !important;
        }
      }
    }
}
</style>
